import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import './AppHeader.css';

const AppHeader = ({
  title,
  onBack,
  backLabel = '← Ana Sayfa',
  onGoToProfile,
  onGoToEventManagement,
  onGoToAdminPanel,
  onGoToVenueManage,
  onGoToQrScanner,
}) => {
  const { user, logout } = useAuth();
  const [showUserMenu, setShowUserMenu]   = useState(false);
  const [showAdminMenu, setShowAdminMenu] = useState(false);

  const role         = user?.role;
  const isAdmin      = role === 'Admin';
  const isEventOwner = role === 'EventOwner' || isAdmin;

  const closeAll = () => { setShowUserMenu(false); setShowAdminMenu(false); };

  return (
    <header className="app-header">
      <div className="app-header-inner">

        {/* Sol — geri + başlık */}
        <div className="app-header-left">
          {onBack && (
            <button className="app-header-back" onClick={onBack}>
              {backLabel}
            </button>
          )}
          {title && <h2 className="app-header-title">{title}</h2>}
        </div>

        {/* Orta — logo */}
        <div className="app-header-logo" onClick={onBack} style={{ cursor: onBack ? 'pointer' : 'default' }}>
          <span className="app-header-logo-icon">🎭</span>
          <span className="app-header-logo-name">Gişe Görevlisi</span>
        </div>

        {/* Sağ — menüler */}
        <div className="app-header-right">

          {/* Yönetim dropdown */}
          {isEventOwner && (
            <div className="app-header-menu-wrap">
              <button
                className="app-header-admin-btn"
                onClick={() => { setShowAdminMenu(m => !m); setShowUserMenu(false); }}
              >
                <i className="fa-solid fa-gear" /> Yönetim <span className="app-header-chevron"><i className="fa-solid fa-chevron-down" /></span>
              </button>
              {showAdminMenu && (
                <div className="app-header-dropdown">
                  {isEventOwner && (
                    <button onClick={() => { closeAll(); onGoToEventManagement?.(); }}>
                      <i className="fa-solid fa-calendar-days" /> Etkinlik Yönetimi
                    </button>
                  )}
                  {isEventOwner && (
                    <button onClick={() => { closeAll(); onGoToAdminPanel?.(); }}>
                      <i className="fa-solid fa-shield-halved" /> Admin Paneli
                    </button>
                  )}
                  {isAdmin && (
                    <button onClick={() => { closeAll(); onGoToVenueManage?.(); }}>
                      <i className="fa-solid fa-building-columns" /> Salon Yönetimi
                    </button>
                  )}
                  {isAdmin && (
                    <button onClick={() => { closeAll(); onGoToQrScanner?.(); }}>
                      <i className="fa-solid fa-qrcode" /> QR Okuyucu
                    </button>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Kullanıcı dropdown */}
          {user && (
            <div className="app-header-menu-wrap">
              <button
                className="app-header-user-btn"
                onClick={() => { setShowUserMenu(m => !m); setShowAdminMenu(false); }}
              >
                <span className="app-header-avatar"><i className="fa-solid fa-circle-user" /></span>
                <span className="app-header-username">{user.fullName}</span>
                <span className="app-header-chevron"><i className="fa-solid fa-chevron-down" /></span>
              </button>
              {showUserMenu && (
                <div className="app-header-dropdown app-header-user-dropdown">
                  <div className="app-header-user-info">
                    <div className="app-header-user-name">{user.fullName}</div>
                    <div className="app-header-user-role">{
                      role === 'Admin'      ? <><i className="fa-solid fa-key" /> Admin</> :
                      role === 'EventOwner' ? <><i className="fa-solid fa-star" /> Etkinlik Sahibi</> :
                                             <><i className="fa-solid fa-ticket" /> Üye</>
                    }</div>
                  </div>
                  <div className="app-header-divider" />
                  <button onClick={() => { closeAll(); onGoToProfile?.(); }}>
                    <i className="fa-solid fa-user" /> Profilim
                  </button>
                  <div className="app-header-divider" />
                  <button className="app-header-logout" onClick={() => { closeAll(); logout(); }}>
                    <i className="fa-solid fa-right-from-bracket" /> Çıkış Yap
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AppHeader;